module.exports = __webpack_public_path__ + "facelifting_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_4_before.jpg
// module id = 1056
// module chunks = 0